import styled from 'styled-components'

import spinner from './spinner.gif'

const StyledLoader = styled.div`
  text-align: center;
`

interface LoaderProps {
  className?: object
}

const Loader = ({ className }: LoaderProps) => {
  return (
    // @ts-expect-error
    <StyledLoader className={className} data-id="wg-loader">
      <img src={spinner} alt="Loading..." />
    </StyledLoader>
  )
}

Loader.displayName = 'Loader'

export default Loader
